var _rect, _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaySuccessIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 136,
    viewBox: "0 0 194 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 33,
    width: 53,
    height: 53,
    rx: 26.5,
    transform: "rotate(90 165 33)",
    fill: "#F1EDF7"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.5,
    cy: 12.5,
    rx: 4.5,
    ry: 4.5,
    transform: "rotate(90 29.5 12.5)",
    fill: "#00FFFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.6011 98.509C57.0505 98.6737 57.0504 99.326 56.601 99.4905C50.7256 101.641 48.6409 103.725 46.4905 109.601C46.326 110.05 45.6736 110.05 45.5089 109.601C43.3568 103.728 41.2739 101.644 35.3989 99.491C34.9495 99.3263 34.9496 98.674 35.399 98.5095C41.2744 96.3587 43.3592 94.2747 45.5095 88.3992C45.674 87.9498 46.3264 87.9496 46.4911 88.399C48.6432 94.2723 50.7261 96.3562 56.6011 98.509Z",
    fill: "url(#paint0_linear_415_85607)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5011 87.3538C101.58 87.3538 105.698 83.2364 105.698 78.1574C105.698 73.0783 101.58 68.9609 96.5011 68.9609C91.4221 68.9609 87.3047 73.0783 87.3047 78.1574C87.3047 83.2364 91.4221 87.3538 96.5011 87.3538Z",
    stroke: "url(#paint1_linear_415_85607)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7265 50.1083H52.3582C51.3826 50.1083 50.447 49.7207 49.7571 49.0308C49.0672 48.341 48.6797 47.4053 48.6797 46.4297V24.3583C48.6797 23.3826 49.0672 22.447 49.7571 21.7571C50.447 21.0672 51.3826 20.6797 52.3582 20.6797H140.644C141.619 20.6797 142.555 21.0672 143.245 21.7571C143.935 22.447 144.322 23.3826 144.322 24.3583V46.4297C144.322 47.4053 143.935 48.341 143.245 49.0308C142.555 49.7207 141.619 50.1083 140.644 50.1083H136.276",
    stroke: "url(#paint2_linear_415_85607)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5017 56.2533C95.9938 56.2533 95.582 55.8416 95.582 55.3337C95.582 54.8258 95.9938 54.4141 96.5017 54.4141",
    stroke: "url(#paint3_linear_415_85607)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5 56.2533C97.0079 56.2533 97.4196 55.8416 97.4196 55.3337C97.4196 54.8258 97.0079 54.4141 96.5 54.4141",
    stroke: "url(#paint4_linear_415_85607)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5017 102.308C95.9938 102.308 95.582 101.896 95.582 101.388C95.582 100.88 95.9938 100.469 96.5017 100.469",
    stroke: "url(#paint5_linear_415_85607)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5039 102.308C97.0118 102.308 97.4235 101.896 97.4235 101.388C97.4235 100.88 97.0118 100.469 96.5039 100.469",
    stroke: "url(#paint6_linear_415_85607)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M118.288 39.9922H74.7115C72.5237 39.9922 70.75 41.6392 70.75 43.6708V112.644C70.75 114.675 72.5237 116.323 74.7115 116.323H118.288C120.476 116.323 122.25 114.675 122.25 112.644V43.6708C122.25 41.6392 120.476 39.9922 118.288 39.9922Z",
    stroke: "url(#paint7_linear_415_85607)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_415_85607",
    x1: 57.7273,
    y1: 98.8033,
    x2: 18.5315,
    y2: 111.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_415_85607",
    x1: 105.489,
    y1: 78.0066,
    x2: 75.4501,
    y2: 88.1172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_415_85607",
    x1: 143.236,
    y1: 35.1527,
    x2: 64.0709,
    y2: 121.752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_415_85607",
    x1: 96.4912,
    y1: 55.3186,
    x2: 94.8652,
    y2: 55.5923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_415_85607",
    x1: 97.4092,
    y1: 55.3186,
    x2: 95.7832,
    y2: 55.5923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_415_85607",
    x1: 96.4912,
    y1: 101.373,
    x2: 94.8652,
    y2: 101.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_415_85607",
    x1: 97.4131,
    y1: 101.373,
    x2: 95.7871,
    y2: 101.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_415_85607",
    x1: 121.665,
    y1: 77.5317,
    x2: 32.6206,
    y2: 97.7532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaySuccessIcon);
export default __webpack_public_path__ + "static/media/pay_success_icon.dea82703ccfef1dfa431d5ffe566c599.svg";
export { ForwardRef as ReactComponent };